<div class="content">
  <div class="row">
    <nz-select [(ngModel)]="selectedProp1" [compareWith]="compareFn" nzShowSearch nzAllowClear
      (ngModelChange)="setProp()">
      @for (col of columnDefinition; track $index) {
        <nz-option [nzLabel]="col.headerName!" [nzValue]="col"></nz-option>
      }
    </nz-select>
    <div class="delimiter">/</div>
    <nz-select [(ngModel)]="selectedProp2" [compareWith]="compareFn" nzShowSearch nzAllowClear
      (ngModelChange)="setProp()">
      @for (col of columnDefinition; track $index) {
        <nz-option [nzLabel]="col.headerName!" [nzValue]="col"></nz-option>
      }
    </nz-select>
  </div>
  <div class="row">
    <div class="drag placeholder-value">Beispielwert</div>
    <div class="delimiter">/</div>
    <div class="drag placeholder-value">Beispielwert</div>
  </div>
</div>
